import { TagGroup } from "../models/tagGroup.model";
import { TimePeriods } from "../models/timePeriods.model";
import auth from "@services/auth/auth";

export function setSessionData(accessToken: string): void {
  const expirationDate = new Date();
  // expirationDate.setSeconds(expirationDate.getSeconds() + expirationTime);
  //TODO
  auth.saveUserSession(accessToken, expirationDate);
  //history.push('/');
}

export function getToken(): String {
  return auth.getToken();
}

export function formatDateCharts(date: string): String {
  const [_, m, d] = date.split("-");
  let month = m;
  let day = d;
  if (m.startsWith("0")) month = m.replace("0", "");
  if (d.startsWith("0")) day = d.replace("0", "");
  return `${month}/${day}`;
}

export function getFiltersDate(timePeriods: TimePeriods[], timePeriodSelected: string) {
  const date: TimePeriods | undefined = timePeriods?.find(time => time.key == timePeriodSelected);
  const startDate = date?.start_date ?? "";
  const endDate = "";
  return { startDate, endDate };
}

/**
 * this function was made to show the Month as string, without being afecting by the timezone
 */
export function formatDateChart(date: string) {
  const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  const currentMonth = date.substring(5, 7)
  let month = "";
  if (Number(currentMonth) >= 10) {
    month = months[Number(currentMonth) - 1]
  } else {
    month = months[Number(currentMonth.substring(1)) - 1]
  }
  const formattedDate = `${month} ${date.substring(8, 10)}, ${date.substring(0, 4)}`;
  return formattedDate
}

export function formatLongDate(date: string) {
  return new Date(date).toLocaleDateString('us-PT', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
    second: 'numeric',
  })
}
export function monthBackDate(date: Date) {
  const daysBefore = new Date(date.getTime() - 30 * 24 * 60 * 60 * 1000)
  return daysBefore.toISOString().slice(0, 10);
}

export function converHexToRgb(hex: string) {
  hex = hex.replace(/^#/, '');
  if (hex.length !== 6) {
    throw new Error('Invalid hex color code');
  }
  const r = parseInt(hex.substring(0, 2), 16);
  const g = parseInt(hex.substring(2, 4), 16);
  const b = parseInt(hex.substring(4, 6), 16);
  return [r, g, b];
}

export function capitalizeFirstLetter(str: string): string {
  if (!str) {
    return str; // Handle empty strings
  }
  return str.charAt(0).toUpperCase() + str.slice(1);
}

export function parseFontString(input: string): { familyName: string, weight: string, italic: boolean } {
    const parts = input.split("-");
    if (parts.length > 1) {
      const last = parts[parts.length - 1].toLowerCase();
      const weightItalicPattern = /^\d{3}(italic)?$/;
      const italicOnlyPattern = /^italic$/;
      if (italicOnlyPattern.test(last) || weightItalicPattern.test(last)) {
        const familyName = parts.slice(0, -1).join("-");
        const italic = last.includes("italic");
        const weightRaw = last.replace("italic", "");
        const weight = /^\d{3}$/.test(weightRaw) ? weightRaw : "400";

        return { familyName, weight, italic };
      }
    }
    return {
      familyName: input,
      weight: "400",
      italic: false,
    };
  }

export function rgbToHex(r: number, g: number, b: number) {
  return "#" + ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1).toUpperCase();
}

export async function convertFileToBase64(file: any) {
  const base64: any = await new Promise((resolve) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => console.log("error uploading ", error);
  });
  return base64;
}

export async function converBase64ToFile(base64String: string, filename: string) {
  // Decode the base64 string
  const byteCharacters = atob(base64String.split(',')[1]);  // remove any potential data URI prefix

  // Create a byte array for the file data
  const byteArray = new Uint8Array(byteCharacters.length);

  // Fill the byte array with decoded data
  for (let i = 0; i < byteCharacters.length; i++) {
    byteArray[i] = byteCharacters.charCodeAt(i);
  }

  // Create a Blob object with the byte array and specify the MIME type (optional)
  const blob = new Blob([byteArray], { type: 'application/octet-stream' });

  // Create a File object (if you need the file to be a "real" file with a name)
  const file = new File([blob], filename, { type: 'application/octet-stream' });

  return file;
}

export function downloadImage(base64String: string, fileName: string) {
  const link = document.createElement('a');
  link.href = `${base64String}`;
  link.download = fileName;
  link.click();
}

export async function downloadImageFromUrl(url: string, filename: string) {
  const response = await fetch(url, { mode: 'no-cors' });
  const blob = await response.blob();
  const blobUrl = URL.createObjectURL(blob);

  const link = document.createElement('a');
  link.href = blobUrl;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);

  // Cleanup
  URL.revokeObjectURL(blobUrl);
}
export function isoDateFormat(date: string) {
  const localDate = new Date(date);
  const year = localDate.getFullYear();
  const month = String(localDate.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed, so we add 1
  const day = String(localDate.getDate()).padStart(2, '0');

  return `${year}-${month}-${day}`;
}

export function getDateInCaliforniaTimeZone(dateString: string) {
  const inputDate = new Date(dateString);
  const californiaOffset = -8 * 60; // Default to PST (UTC-8)
  const now = new Date();
  const currentOffset = now.getTimezoneOffset();
  if (currentOffset !== californiaOffset) {
    // Adjust to PDT (UTC-7)
    const californiaDate = new Date(inputDate.getTime() + (currentOffset - californiaOffset) * 60000);
    return californiaDate;
  }

  // Return the input date adjusted to California Standard Time (UTC-8)
  return new Date(inputDate.getTime() + (currentOffset - californiaOffset) * 60000);
}

export function isUUID(id: string) {
  const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
  return uuidRegex.test(id);
}

export function hexToRgb(hex: string): string {
  const sanitized = hex.replace('#', '');
  const bigint = parseInt(sanitized, 16);
  const r = (bigint >> 16) & 255;
  const g = (bigint >> 8) & 255;
  const b = bigint & 255;
  return JSON.stringify([r, g, b]);
}

export function isHexColor(value: string): boolean {
  return /^#([0-9A-Fa-f]{3}|[0-9A-Fa-f]{6})$/.test(value);
}

export function rgbArrayToHex(rgb: [number, number, number] | any): string {
  if (!rgb) return ""
  return (
    '#' +
    rgb
      .map((value: { toString: (arg0: number) => any; }) => {
        const hex = value.toString(16);
        return hex.length === 1 ? '0' + hex : hex;
      })
      .join('')
  );
}

export async function fetchGoogleFontFile(
  family: string,
  bold: boolean = false,
  italic: boolean = false
): Promise<File> {
  // normalize inputs
  const weight = bold ? "700" : "400";
  const styleCode = italic ? "1" : "0";
  const familyParam = family.replace(/\s+/g, "+");

  // 1) build the CSS2 URL
  const cssUrl = `https://fonts.googleapis.com/css2?family=${familyParam}:ital,wght@${styleCode},${weight}&display=swap`;

  // 2) fetch the CSS
  const cssResp = await fetch(cssUrl);
  if (!cssResp.ok) {
    throw new Error(`Could not fetch font CSS for ${family}`);
  }
  const cssText = await cssResp.text();

  // 3) extract all url(...) format(...) entries
  const regex = /url\(([^)]+)\)\s*format\(['"]?([^'")]+)['"]?\)/g;
  const candidates: { url: string; format: string }[] = [];
  let m: RegExpExecArray | null;
  while ((m = regex.exec(cssText)) !== null) {
    candidates.push({ url: m[1], format: m[2].toLowerCase() });
  }
  if (!candidates.length) {
    throw new Error(`No font URLs found in Google Fonts CSS for ${family}`);
  }

  // 4) pick preferred format order: woff2 → otf → ttf → anything else
  const choice = candidates.find(c => c.format === "woff2")
            || candidates.find(c => c.format.includes("opentype"))
            || candidates.find(c => c.format.includes("truetype"))
            || candidates[0];

  // 5) download the chosen file
  const fontResp = await fetch(choice.url);
  if (!fontResp.ok) {
    throw new Error(`Failed to download font from ${choice.url}`);
  }
  const buffer = await fontResp.arrayBuffer();

  // 6) determine extension from URL (before query)
  const urlPath = choice.url.split("?")[0];
  const ext = urlPath.split(".").pop() || "font";

  // 7) wrap as File
  const fileName = `${family.replace(/\s+/g, "-")}-${weight}${italic?"italic":""}.${ext}`;
  return new File([buffer], fileName, { type: `font/${ext}` });
}

export async function urlToFile(
  url: string,
  fallbackName = ""
): Promise<File> {
  const fallback = fallbackName || crypto.randomUUID();
  const response = await fetch(url, {
    method: 'GET',
    mode: 'cors',        
    cache:  'no-cache',
    credentials: 'omit',
  });
  const blob = await response.blob();
  const contentType = response.headers.get("Content-Type") || blob.type;

  const mimeToExt: Record<string, string> = {
    "image/jpeg": "jpg",
    "image/png": "png",
    "image/gif": "gif",
    "image/webp": "webp",
    "image/svg+xml": "svg",
    "application/pdf": "pdf",
    "text/plain": "txt",
    "application/json": "json",
    "video/mp4": "mp4",
    "video/webm": "webm", 
    "audio/mpeg": "mp3",
    "audio/wav": "wav",
    "video/quicktime": "mov",
  };

  let extension = mimeToExt[contentType] || "";
  if (!extension) {
    const urlExtMatch = url.split("/").pop()?.split("?")[0].split(".").pop();
    if (urlExtMatch && urlExtMatch.length <= 5) {
      extension = urlExtMatch;
    }
  }

  const filename = extension ? `${fallback}.${extension}` : fallback;
  console.log("Filename: " + filename)
  return new File([blob], filename, { type: contentType });
}

export function debugSetter<T extends (...args: any[]) => any>(
  name: string,
  fn: T
): T {
  return ((...args: Parameters<T>) => {
    console.log(`[VALTIO DEBUG] ${name} called with:`, ...args);
    return fn(...args);
  }) as T;
}

export function normalizeColor(value: string | number[]): string {
  if (typeof value === "string") {
    return value;
  }
  if (Array.isArray(value)) {
    return JSON.stringify(value);
  }
  return "[0, 0, 0]";
}

export function getFileExtension(url: string): string | null {
  const match = url.split('?')[0].match(/\.([a-zA-Z0-9]+)$/);
  return match ? match[1].toLowerCase() : null;
}

export function parseInputValue(value: string | number): string | number {
  // If it's already a number, return it as-is
  if (typeof value === 'number') {
    return value;
  }
  // Trim the string in case of extra whitespace
  const trimmed = value.trim();
  // Check if it's a valid number (e.g. "0", "42", "3.14")

  const parsedNumber = Number(trimmed);
  if (!isNaN(parsedNumber)) {
    return parsedNumber;
  }
  // Otherwise, return as string
  return value;
}

export function convertTagGroupsToMap(tagGroups: TagGroup[]): { [key: number]: number[] } {
  const map: { [key: number]: number[] } = {};
  
  for (const group of tagGroups) {
    if (group.tags.length > 0) {
    map[group.id] = group.tags.map(tag => tag.id);
    }
    // If tags are empty, skip the group
  }
  
  return map;
}

export function numberFormat(price: number | null | undefined): string {
  const n = Number(price);
  if (isNaN(n)) return "0";
  return new Intl.NumberFormat("en-US", {
    maximumFractionDigits: 0,
    minimumFractionDigits: 0,
  }).format(n);
}

export function percentFormat(value: number | null | undefined): string {
  const n = Number(value);
  if (isNaN(n)) return "0";
  return new Intl.NumberFormat("en-US", {
    maximumFractionDigits: 2,
    minimumFractionDigits: 0,
  }).format(n);
}

export function stripHtmlTags (html: string) {
  const tempDiv = document.createElement('div');
  tempDiv.innerHTML = html;
  return tempDiv.textContent || tempDiv.innerText || '';
}

export function statusBadgeVariant(status: string) {
  switch (status?.toLowerCase()) {
    case "complete":
    case "completed":
      return "success"
    case "in progress":
    case "in_progress":
      return "primary"
    case "blocked":
      return "danger"
    default:
      return "secondary"
  }
}

export function stageBadgeVariant(stage: string) {
  switch (stage?.toLowerCase()) {
    case "scope":
      return "secondary"
    case "setup":
      return "info"
    case "content":
      return "warning"
    case "publish":
      return "primary"
    case "monitor":
      return "success"
    case "close":
    case "complete":
    case "completed":
      return "dark"
    default:
      return "secondary"
  }
}
